export const GET_DOCUMENT_IMAGE_ATTEMPT = 'GET_DOCUMENT_IMAGE_ATTEMPT';
export type GET_DOCUMENT_IMAGE_ATTEMPT = typeof GET_DOCUMENT_IMAGE_ATTEMPT;

export const GET_DOCUMENT_IMAGE_SUCCESS = 'GET_DOCUMENT_IMAGE_SUCCESS';
export type GET_DOCUMENT_IMAGE_SUCCESS = typeof GET_DOCUMENT_IMAGE_SUCCESS;

export const GET_DOCUMENT_IMAGE_FAILURE = 'GET_DOCUMENT_IMAGE_FAILURE';
export type GET_DOCUMENT_IMAGE_FAILURE = typeof GET_DOCUMENT_IMAGE_FAILURE;



// WEBPACK FOOTER //
// ./src/actions/project/get-document-image/Types.tsx